export const applicationsWithCurr = [
  {
    key: 'aplicacaoAcComCurr',
    name: 'ar-condicionado',
    hasPliq: false,
    hasPsuc: false,
  },
  {
    key: 'aplicacaoAcComPliqCurr',
    name: 'ar-condicionado',
    hasPliq: true,
    hasPsuc: false,
  },
  {
    key: 'aplicacaoAcComPsucCurr',
    name: 'ar-condicionado',
    hasPliq: false,
    hasPsuc: true,
  },
  {
    key: 'aplicacaoCfComCurr',
    name: 'camara-fria',
    hasPliq: false,
    hasPsuc: false,
  },
  {
    key: 'aplicacaoCfComPliqCurr',
    name: 'camara-fria',
    hasPliq: true,
    hasPsuc: false,
  },
  {
    key: 'aplicacaoCfComPsucCurr',
    name: 'camara-fria',
    hasPliq: false,
    hasPsuc: true,
  },
  {
    key: 'aplicacaoFcComCurr',
    name: 'fancoil',
    hasPliq: false,
    hasPsuc: false,
  },
  {
    key: 'aplicacaoChComCurr',
    name: 'chiller',
    hasPliq: false,
    hasPsuc: false,
  },
  {
    key: 'aplicacaoChComPliqCurr',
    name: 'chiller',
    hasPliq: true,
    hasPsuc: false,
  },
  {
    key: 'aplicacaoChComPsucCurr',
    name: 'chiller',
    hasPliq: false,
    hasPsuc: true,
  },
  {
    key: 'aplicacaoTcComPsucCurr',
    name: 'trocador-de-calor',
    hasPliq: false,
    hasPsuc: true,
  },
];

export const applicationsWithoutCurr = [
  {
    key: '1acComPliq',
    name: 'ar-condicionado',
    hasPliq: true,
    hasPsuc: false,
  },
  {
    key: '2acComPsuc',
    name: 'ar-condicionado',
    hasPliq: false,
    hasPsuc: true,
  },
  {
    key: '4acSemPliqPsuc',
    name: 'ar-condicionado',
    hasPliq: false,
    hasPsuc: false,
  },
  {
    key: '3acComPliqPsuc',
    name: 'ar-condicionado',
    hasPliq: true,
    hasPsuc: true,
  },
  {
    key: '5cfComPliq',
    name: 'camara-fria',
    hasPliq: true,
    hasPsuc: false,
  },
  {
    key: '6cfComPsuc',
    name: 'camara-fria',
    hasPliq: false,
    hasPsuc: true,
  },
  {
    key: '7cfComPliqPsuc',
    name: 'camara-fria',
    hasPliq: true,
    hasPsuc: true,
  },
  {
    key: '8cfSemPlicPsuc',
    name: 'camara-fria',
    hasPliq: false,
    hasPsuc: false,
  },
  {
    key: '9fancoil',
    name: 'fancoil',
    hasPliq: false,
    hasPsuc: false,
  },
  {
    key: '10chillerComPliq',
    name: 'chiller',
    hasPliq: true,
    hasPsuc: false,
  },
  {
    key: '11chillerComPsuc',
    name: 'chiller',
    hasPliq: false,
    hasPsuc: true,
  },
  {
    key: '12chillerComPliqPsuc',
    name: 'chiller',
    hasPliq: true,
    hasPsuc: true,
  },
  {
    key: '13chillerSemPliqPsuc',
    name: 'chiller',
    hasPliq: false,
    hasPsuc: false,
  },
  {
    key: '14trocadorCalor',
    name: 'trocador-de-calor',
    hasPliq: false,
    hasPsuc: false,
  },
];
